/* eslint-disable no-underscore-dangle -- __uspapi is the IAB US Privacy API global name */
import { getUspString } from './helpers';
import type { UspApiCallback } from './types';

/**
 * Registers a minimal IAB US Privacy API stub on `window.__uspapi`.
 *
 * Only the `getUSPData` command is implemented. The USP string is computed
 * lazily on each call (via `getUspString`) so it reflects geo once the async
 * lookup resolves — before then it returns '1---'.
 *
 * Registered immediately on app init (Phase 1 of the two-phase timing).
 */
export const registerUspApi = (): void => {
	if (typeof window === 'undefined' || window.__uspapi) {
		return;
	}

	window.__uspapi = (
		command: string,
		_version: number,
		callback: UspApiCallback,
	) => {
		if (command === 'getUSPData') {
			callback({ version: 1, uspString: getUspString() }, true);
		}
	};
};
